import { OMS_DELIVERY_TRACKER_PATH } from '../../constants/paths';
import { apiB2B } from '../axios-client';
export var GetDeliveryTrackerAPI = function (requestData) {
    return apiB2B.post(OMS_DELIVERY_TRACKER_PATH, requestData);
};
